module.exports = __webpack_public_path__ + "img/btn_register.83df36e9.png";